import React, { useState, useEffect, useRef } from 'react';
import { shopContext } from '../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import { loadTossPayments } from '@tosspayments/payment-sdk';
import queryString from 'query-string';
import { act } from 'react';

const SeatReservePay = (props) => {
  const { loginId } = props;
  const query = queryString.parse(props.childProps.location.search);
  const { o, a, n, t } = query;
  console.log(o, a, n, t);
  const onUnload = (e) => {
    e.preventDefault();
    window.opener.postMessage({ show: false });
  };

  const pay = async () => {
    // const cKey = 'test_ck_qLlDJaYngrooqgwBpNmrezGdRpXx';
    const cKey = 'live_ck_d26DlbXAaV0P42ERJN0VqY50Q9RB';
    const toasspayments = await loadTossPayments(cKey);
    await toasspayments.requestPayment('간편결제', {
      amount: a,
      orderId: o,
      orderName: n,
      customerName: loginId,
      successUrl: `${window.location.origin}/seatSucc`,
      // successUrl: `http://son.aniplustv.com:4000/paySucc`,
      failUrl: `${window.location.origin}/seatFail`,
      flowMode: 'DIRECT',
      easyPay: t,
    });
  };

  useEffect(() => {
    window.addEventListener('beforeunload', onUnload);
    pay();

    return () => {
      window.removeEventListener('beforeunload', onUnload);
    };
  }, []);

  return (
    <div>
      <div>결제창</div>
    </div>
  );
};

export default shopContext(withRouter(SeatReservePay));
